<button
  class="button"
  *ngIf="isCartLineInCart$ | async"
  (click)="removeCartLine(); $event.stopPropagation()"
  [style.margin-right.px]="marginRightPx"
>
  <svg-icon class="icon" src="/assets/icons/trash.svg"></svg-icon>
</button>
